import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LayoutComponent } from 'src/app/components/layout/layout.component';
import { PageNotFoundComponent } from 'src/app/components/layout/page-not-found.component';
import { AuthenticationLoginComponent } from 'src/app/components/authentication/authentication-login/authentication-login.component';

import { AuthBasicGuard } from './guards/auth-basic.guard';
import { AuthAdminGuard } from './guards/auth-admin-guard';
import { ProfileComponent } from './components/profile/profile.component';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { DataMaintenanceComponent } from 'src/app/components/data-maintenance/data-maintenance.component';
import { MyMemberComponent } from './components/my-member/my-member.component';
import { DocumentTreeComponent } from './components/document-tree/document-tree.component';

import { UserManagementComponent } from './components/administration/user-management.component';
import { MemberManagementComponent } from './components/administration/member-management.component';
import { SectionManagementComponent } from './components/administration/section-management.component';
import { ExportCSVComponent } from './components/administration/export-csv.component';
import { GroupManagementComponent } from './components/administration/groups/group-management.component';
import { DataConfirmationComponent } from './components/authentication/data-confirmation.component';
import { DataProtectionComponent } from './components/single-page/data-protection.component';
import { ContactComponent } from './components/single-page/contact.component';
import { ImprintComponent } from './components/single-page/imprint.component';
import { IndependantLayoutComponent } from './components/layout/independant-layout.component';
import {ForgotPasswordComponent} from './components/forgot-password/forgot-password.component';
import {ChangeForgottenPasswordComponent} from './components/change-forgotten-password/change-forgotten-password.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { EventEditorComponent } from './components/calendar/event-editor.component';
import { NewsComponent } from './components/news/news.component';
import { NewsEditorComponent } from './components/news/news-editor.component';
import { EventViewerComponent } from './components/calendar/event-viewer.component';
import { NewsPrintComponent } from './components/news/news-print.component';
import { StartComponent } from './components/start/start-component';
import { AuthAdmin_Or_AdminMember_Guard } from './guards/auth-admin-or-admin-member-guard';
import { UserCreatorComponent } from './components/editors/user-creator.component';
import { NewsViewerComponent } from './components/news/news-viewer.component';
import { EventRegistrationComponent } from './components/calendar/event-registration.component';
import { EventRegistrationViewerComponent } from './components/calendar/event-registration-viewer.component';
import { Manage2FAComponent } from './components/authentication/manage-2fa.component';
import { DocumentExchangeListComponent } from './components/document-exchange/document-exchange-list.component';
import { DocumentExchangeCreationComponent } from './components/document-exchange/document-exchange-creation.component';
import { Extend2FAComponent } from './components/authentication/extend-2fa/extend-2fa.component';
import { ExchangeGuard } from './guards/exchange.guard';
import { ChatComponent } from './components/chat/chat.component';
import { GroupChatEditorComponent } from './components/chat/group-chat-editor.component';
import { ChatSearchContactComponent } from './components/chat/chat-search-contact.component';
import { DynamicFormManagerComponent } from './components/dynamic-form/dynamic-form-manager.component';
import { DynamicFormEditorComponent } from './components/dynamic-form/dynamic-form-editor.component';
import { YearManagementComponent } from './components/administration/year-management.component';
import { MemberCreatorComponent } from './components/administration/member-creator.component';
import { ChangePasswordComponent } from './components/profile/change-pwd.component';
import { PasswordInputComponent } from './components/password-input/password-input.component';
import {BestandComponent} from "./components/bestand/bestand/bestand.component";
import {AntragComponent} from "./components/bestand/antrag/antrag.component";
import {BriefeComponent} from "./components/bestand/briefe/briefe.component";
import {
  AuthenticationRegisterComponent
} from "./components/authentication/authentication-register/authentication-register.component";
import {
  AuthenticationPlansComponent
} from "./components/authentication/authentication-plans/authentication-plans.component";
import { PaymentsComponent } from './components/payments/payments.component';
import { LegalDocumentManagementComponent } from './components/administration/legal-documents-management.component';
import {VgvComponent} from "./components/bestand/vgv/vgv.component";


const routes: Routes = [

	{
	  path: 'auth/login',
	  component: AuthenticationLoginComponent,
	  data: { title: 'Login' }
	},
  { path: 'auth/register', component: AuthenticationRegisterComponent },
  { path: 'auth/plans', component: AuthenticationPlansComponent },
	{
	  path: 'Datenschutz',
	  component: DataConfirmationComponent,
	  data: { title: 'Datenschutzbestätigung' }
	},
	{
		path: '2FA',
		component: Manage2FAComponent,
		data: { title: 'Manage2FA'}
	},
	{
		path: 'E2FA',
		component: Extend2FAComponent,
		data: { title: 'Extend2FA'}
	},
	{
	  path: 'login/passwort-vergessen',
	  component: ForgotPasswordComponent,
	  data: { title: 'Passwort vergessen' }
	},
	{
	  path: 'passwordReset/:token',
	  component: ChangeForgottenPasswordComponent,
	  data: { title: 'Passwort zurücksetzen' }
	},
	{
	  path: 'Datenschutzerklärung',
	  component: IndependantLayoutComponent,
	  children: [{ path: '', component: DataProtectionComponent }],
	  data: { title: 'Datenschutzerklärung' }
	},
	{
	  path: 'Kontakt',
	  component: IndependantLayoutComponent,
	  children: [{ path: '', component: ContactComponent }],
	  data: { title: 'Kontakt' }
	},
	{
	  path: 'Impressum',
	  component: IndependantLayoutComponent,
	  children: [{ path: '', component: ImprintComponent }],
	  data: { title: 'Impressum' }
	},
	{
	  path: 'News_drucken',
	  component: IndependantLayoutComponent,
	  children: [{ path: '', component: NewsPrintComponent }],
	  data: { title: 'News drucken' }
	},
	{
		path: '',
		component: LayoutComponent,
		children: [
			{
				path: '',
				component: StartComponent,
				data: { title: 'Startseite' }
			},
			{
				path: 'Konto/Profil',
				component: ProfileComponent,
				data: { title: 'Profil' }
			},
			{
				path: 'Statistik',
				component: StatisticsComponent,
				data: { title: 'Statistik' }
			},
			{
				path: 'Datenpflege',
				component: DataMaintenanceComponent,
				data: { title: 'Datenpflege' }
			},
			{
				path: 'Mitgliedsdaten',
				component: MyMemberComponent,
				canActivate: [ AuthBasicGuard, AuthAdmin_Or_AdminMember_Guard ],
				data: { title: 'Mitgliedsdaten' }
			},
			{
				path: 'Dokumente',
				component: DocumentTreeComponent,
				canActivate: [ AuthBasicGuard ],
				data: { title: 'Dokumente' }
			},
			{
				path: 'Benutzerverwaltung',
				data: { title: 'Benutzerverwaltung' },
				canActivate: [ AuthBasicGuard, AuthAdmin_Or_AdminMember_Guard ],
				children: [
					{ path: "Benutzererstellung", component: UserCreatorComponent },
					{ path: "", component: UserManagementComponent }
				]

			},
			{
				path: 'Mitgliederverwaltung',
				canActivate: [ AuthBasicGuard, AuthAdminGuard ],
				data: { title: 'Mitgliederverwaltung' },
				children: [
					{ path: "Mitgliedererstellung", component: MemberCreatorComponent },
					{ path: "", component: MemberManagementComponent }
				]
			},
			{
				path: 'Spartenverwaltung',
				component: SectionManagementComponent,
				canActivate: [AuthBasicGuard, AuthAdminGuard],
				data: { title: 'Spartenverwaltung' }
			},
			{
				path: 'Berichtsjahrverwaltung',
				component: YearManagementComponent,
				canActivate: [AuthBasicGuard, AuthAdminGuard],
				data: { title: 'Berichtsjahrverwaltung' }
			},
			{
				path: 'Gruppenverwaltung',
				component: GroupManagementComponent,
				canActivate: [AuthBasicGuard, AuthAdminGuard],
				data: { title: 'Gruppenverwaltung' }
			},
			{
				path: 'Rechtsdokumente',
				component: LegalDocumentManagementComponent,
				canActivate: [ AuthAdminGuard ],
				data: { title: 'Rechtsdokumente' }
			},
			{
				path: 'Export',
				component: ExportCSVComponent,
				data: { title: 'Datenexport' }
			},
      {
              path: 'Export',
              component: ExportCSVComponent,
              data: { title: 'Datenexport' }
      },
      {
              path: 'Zahlungen',
              component: PaymentsComponent,
              data: { title: 'Zahlungen' }
      },
      {
        path: 'Bestandsauskunft',
        component: BestandComponent,
        data: { title: 'Bestandsauskunft' }
      },
      {
        path: 'Briefegenerierung',
        component: BriefeComponent,
        data: { title: 'Briefegenerierung' }
      },

      {
        path: 'Antrag',
        component: AntragComponent,
        data: { title: 'Anträge' }
      },

      {
        path: 'vgv',
        component: VgvComponent,
        data: { title: 'Wohngebäude' }
      },

			{
				path: 'Veranstaltungen',
				children: [
					{ path: 'bearbeiten', component: EventEditorComponent, data: { title: 'Veranstaltung bearbeiten' } },
					{ path: 'visualisieren', component: EventViewerComponent, data: { title: 'Veranstaltung ansehen' } },
					{ path: 'anmelden', component: EventRegistrationComponent, data: { title: 'Veranstaltung anmelden' } },
					{ path: 'anmeldung_übersicht', component: EventRegistrationViewerComponent, data: { title: 'Anmeldungen Übersicht' } },
					{ path: '', component: CalendarComponent, data: { title: 'Kalender' } }
				],
			},
			{
				path: 'Interne_Veranstaltungen',
				children: [
					{ path: 'bearbeiten', component: EventEditorComponent, data: { title: 'Veranstaltung bearbeiten' } },
					{ path: 'visualisieren', component: EventViewerComponent, data: { title: 'Veranstaltung ansehen' } },
					{ path: 'anmelden', component: EventRegistrationComponent, data: { title: 'Veranstaltung anmelden' } },
					{ path: 'anmeldung_übersicht', component: EventRegistrationViewerComponent, data: { title: 'Anmeldungen Übersicht' } },
					{ path: '', component: CalendarComponent, data: { title: 'Kalender' } }
				],
			},
			{
				path: 'Formulare', children: [
					{ path: 'bearbeiten/:formId', component: DynamicFormEditorComponent },
					{ path: 'bearbeiten', component: DynamicFormEditorComponent },
					{ path: '', component: DynamicFormManagerComponent },
				]
			},
			{
				path: 'Austausch',
				children: [
					{ path: 'Erstellen', component: DocumentExchangeCreationComponent, data: { title: 'Austausch erstellen' } },
					{ path: '', component: DocumentExchangeListComponent, data: { title: 'Austausch' } }
				],
				canActivate: [ AuthBasicGuard, ExchangeGuard ]
			},
			{
				path: 'Mitgliederaustausch',
				canActivate: [ AuthBasicGuard ],
				children: [
					{ path: 'gruppenchat', component: GroupChatEditorComponent, data: { title: 'Gruppenchat' } },
					{ path: 'direktchat', component: ChatSearchContactComponent, data: { title: 'Direktchat' } },
					{ path: '', component: ChatComponent, data: { title: 'Chat' } }
				]
			},
			{
				path: 'News',
				children: [
					{ path: 'bearbeiten', component: NewsEditorComponent, data: { title: 'News bearbeiten' } },
					{ path: 'visualisieren', component: NewsViewerComponent, data: { title: 'News ansehen' } },
					{ path: '', component: NewsComponent, data: { title: 'News' } }
				],
			},
			{
				path: 'Nachrichten',
				children: [
					{ path: 'bearbeiten', component: NewsEditorComponent, data: { title: 'News bearbeiten' } },
					{ path: 'visualisieren', component: NewsViewerComponent, data: { title: 'News ansehen' } },
					{ path: '', component: NewsComponent, data: { title: 'News' } }
				],
			},
			{
				path: 'Datenschutzerklärung_',
				component: DataProtectionComponent,
				data: { title: 'Datenschutzerklärung' }
			},
			{
				path: 'Kontakt_',
				component: ContactComponent,
				data: { title: 'Kontakt' }
			},
			{
				path: 'Impressum_',
				component: ImprintComponent,
				data: { title: 'Impressum' }
			},
			{
				path: '**',
				component: PageNotFoundComponent,
				data: { title: 'Seite nicht gefunden' }
			},
		],
		canActivate: [ AuthBasicGuard ],
	},
  ];

@NgModule({
	imports: [ RouterModule.forRoot( routes ) ],
	exports: [ RouterModule ]
})
export class AppRoutingModule {}
